export default "__VITE_ASSET__BtMXjkod__"